import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {QueryResultApi, ResponseApiModel} from '../../shared';
import {Chacra, ChacrasCoreLS, Padron, SueloCore,} from '../models';
import {ApiService} from '../../shared';
import {catchError, map} from 'rxjs/operators';
import {Update} from "@ngrx/entity";
import {ChacrasGetSuelosSuccessAction} from "../../features/store/entities/shared/chacras/chacras.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../core/store/core.state";

@Injectable({
  providedIn: 'root'
})
export class ChacraService extends ApiService<Chacra>{
  protected dataKey = 'rendimientoGeneral';
  protected objectKey = 'Chacras';
  protected sendObjectKey = 'chacras';
  protected sendObjectIdsKey = 'chacrasIds';

  constructor(protected httpClient: HttpClient, private store: Store<AppState>,) {
    super(Chacra, httpClient, 'apiSeguroUrl');
  }

  getList(from: string, params = null): Observable<QueryResultApi<Chacra>> {
    return this.getItems(`query${from}`, this.dataKey, params, false);
  }

  getPadrones(c: Chacra): Observable<Padron[]> {

    const url = this.getUrl('getPadrones');
    const body = { chacraId: c.rendimientoId };

    return this.httpClient.post<{ getResults: ResponseApiModel }>(url, body)
      .pipe(
        map(results => results.getResults),
        map((response: ResponseApiModel) => {
          if (response.success) {
            return this.extractResult(response, 'padrones', []);
          } else {
            throw throwError(response.error.description);
          }
        }),
        catchError(this.handleError)
      );
  }

  getSuelos(c: Chacra): Observable<{sueloLimitanteId: string, suelos: SueloCore[]}> {

    const url = this.getUrl('getSuelos');
    const body = { chacraId: c.rendimientoId };

    return this.httpClient.post<{ getResults: ResponseApiModel }>(url, body)
      .pipe(
        map(results => results.getResults),
        map((response: ResponseApiModel) => {
          if (response.success) {
            const suelos = this.extractResult(response, 'suelos', []);
            const sueloLimitanteId = this.extractResult(response, 'sueloLimitanteId', []);
            return {suelos, sueloLimitanteId};
          } else {
            throw throwError(response.error.description);
          }
        }),
        catchError(this.handleError)
      );
  }

  getLS(c: Chacra): Observable<ChacrasCoreLS> {

    const url = this.getUrl('getFactorLS');
    const body = { chacraId: c.rendimientoId };

    return this.httpClient.post<{ getResults: ResponseApiModel }>(url, body)
      .pipe(
        map(results => results.getResults),
        map((response: ResponseApiModel) => {
          if (response.success) {
            return {
              FactorLS: this.extractResult(response, 'FactorLS', ''),
              FactorL: this.extractResult(response, 'FactorL', ''),
              FactorS: this.extractResult(response, 'FactorS', ''),
              Slope: this.extractResult(response, 'Slope', ''),
              SlopeLength: this.extractResult(response, 'SlopeLength', ''),
              Geometry: this.extractResult(response, 'Geometry', ''),
            };
          } else {
            throw throwError(response.error.description);
          }
        }),
        catchError(this.handleError)
      );
  }

  LoadSuelos(data: { getResults: { sueloLimitanteId: string, suelos: SueloCore[], chacraId: string } }){
    const responseResults = data.getResults;
    let sueloSel = responseResults.suelos.find(s => s.sueloId === responseResults.sueloLimitanteId);
    let sueloChange = {};
    if (sueloSel) {
      sueloChange = {
        chacraSueloLimitanteFactorK: sueloSel.sueloFactorK,
        chacraSueloAsignadoFactorK: sueloSel.sueloFactorK,
        chacraSueloAsignadoId: sueloSel.sueloId,
        chacraSueloLimitanteId: sueloSel.sueloId,
        chacraSueloAsignadoDsc: sueloSel.sueloDesc,
        chacraSueloLimitanteDsc: sueloSel.sueloDesc,
        chacraSueloAsignadoTolerancia: sueloSel.sueloTolerancia,
        chacraSueloLimitanteTolerancia: sueloSel.sueloTolerancia,
        chacraSueloAsignadoSlopeMax: sueloSel.sueloSlopeMax,
        chacraSueloAsignadoSlopeMin: sueloSel.sueloSlopeMin,
        chacraSueloLimitanteSlopeMax: sueloSel.sueloSlopeMax,
        chacraSueloLimitanteSlopeMin: sueloSel.sueloSlopeMin,
        // chacraSueloAsignadoArea: sueloSel.sueloArea,
        // chacraSueloLimitanteArea: sueloSel.sueloArea,
      };
    }

    const uc: Update<Chacra> = {
      id: responseResults.chacraId,
      changes: {
        ...sueloChange,
        suelos: responseResults.suelos,
        suelosLoading: false
      }
    };

    this.store.dispatch(new ChacrasGetSuelosSuccessAction(
      {
        item: uc
      }
    ));
  }
}
